import React from 'react';
import { Building2, FileText, Layers, ShieldCheck } from 'lucide-react';
const stats = [{
  icon: Layers,
  label: 'Industries Analyzed',
  value: '6'
}, {
  icon: FileText,
  label: 'Guides Published',
  value: '40+'
}, {
  icon: Building2,
  label: 'Tool Categories',
  value: '8'
}, {
  icon: ShieldCheck,
  label: 'Editorially Independent',
  value: '100%'
}];
export function StatsBar() {
  return <div className="border-b border-slate-200 bg-white" data-id="element-231">
      <div className="max-w-6xl mx-auto px-6 py-8" data-id="element-232">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-12" data-id="element-233">
          {stats.map((stat, index) => <div key={index} className="flex items-center gap-4 justify-center md:justify-start" data-id="element-234">
              <div className="p-2 bg-teal-50 rounded-lg text-teal-700" data-id="element-235">
                <stat.icon size={20} data-id="element-236" />
              </div>
              <div data-id="element-237">
                <div className="text-xl font-bold text-slate-900 leading-none mb-1" data-id="element-238">
                  {stat.value}
                </div>
                <div className="text-xs font-medium text-slate-500 uppercase tracking-wide" data-id="element-239">
                  {stat.label}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}